import {
  FormControl,
  FormLabel,
  SimpleGrid,
  Stack,
  Switch,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';
import React, { useState } from 'react';

import Card from 'components/card/Card';

import TextField from 'components/fields/TextField';
interface Badge {
  gasId: number;
  gasAssetImage: string;
  gasAssetName: string;
}

const WelcomeScreen: React.FC<{
  handleChange: (e: any) => void;
  formData: any;

  setFormData: React.Dispatch<React.SetStateAction<any>>;
}> = ({ handleChange, formData, setFormData }) => {
  const textColorPrimary = useColorModeValue('secondaryGray.900', 'white');
  const [characterCount, setCharacterCount] = useState(100);

  const handleTextWelcomeChange = (e: any) => {
    const inputText = e.target.value;
    const remainingCharacters = 100 - inputText.length;
    setCharacterCount(remainingCharacters);
    handleChange(e); // Pass the event to the handleChange function to update form data
  };
  const checkvalue = (e: any) => {
    const trimmedValue1 = e.currentTarget.value.trim(); // Use currentTarget instead of target
    if (trimmedValue1 !== '') {
      setFormData((prev: any) => ({
        ...prev,
        gameIsShowAdditionalWelcomeNoteInvalid: false,
      }));
    }
  };
  const maxCharacters = 100;
  return (
    <Stack direction="column" gap="20px">
      <Card>
        <SimpleGrid columns={{ base: 1, md: 1 }} gap="20px">
          <FormControl
            display="flex"
            alignItems="center"
            justifyContent={'space-between'}
            mt="10px"
          >
            <FormLabel
              htmlFor="email-"
              mb="0px"
              fontSize="sm"
              fontWeight="bold"
              color={textColorPrimary}
            >
              Skills
            </FormLabel>
            <Switch
              isChecked={formData.gameIsShowSkill === 'true' ? true : false}
              color="#fff"
              colorScheme="brandScheme"
              size="md"
              id="gameIsShowSkill"
              name="gameIsShowSkill"
              onChange={handleChange}
            />
          </FormControl>
          <FormControl
            display="flex"
            alignItems="center"
            justifyContent={'space-between'}
            mt="10px"
          >
            <FormLabel
              htmlFor="email-"
              mb="0px"
              fontSize="sm"
              fontWeight="bold"
              color={textColorPrimary}
            >
              Story Line
            </FormLabel>
            <Switch
              isChecked={formData.gameIsShowStoryline === 'true' ? true : false}
              color="#fff"
              colorScheme="brandScheme"
              size="md"
              id="gameIsShowStoryline"
              name="gameIsShowStoryline"
              onChange={handleChange}
            />
          </FormControl>
          <FormControl
            display="flex"
            alignItems="center"
            justifyContent={'space-between'}
            mt="10px"
          >
            <FormLabel
              htmlFor="email-"
              mb="0px"
              fontSize="sm"
              fontWeight="bold"
              color={textColorPrimary}
            >
              Learning Outcome
            </FormLabel>
            <Switch
              isChecked={
                formData.gameIsShowLearningOutcome === 'true' ? true : false
              }
              color="#fff"
              colorScheme="brandScheme"
              size="md"
              id="gameIsShowLearningOutcome"
              name="gameIsShowLearningOutcome"
              onChange={handleChange}
            />
          </FormControl>
          <FormControl
            display="flex"
            alignItems="center"
            justifyContent={'space-between'}
            mt="10px"
          >
            <FormLabel
              htmlFor="email-"
              mb="0px"
              fontSize="sm"
              fontWeight="bold"
              color={textColorPrimary}
            >
              Game Duration
            </FormLabel>
            <Switch
              isChecked={
                formData.gameIsShowGameDuration === 'true' ? true : false
              }
              color="#fff"
              colorScheme="brandScheme"
              size="md"
              id="gameIsShowGameDuration"
              name="gameIsShowGameDuration"
              onChange={handleChange}
            />
          </FormControl>
          <FormControl
            display="flex"
            alignItems="center"
            justifyContent={'space-between'}
            mt="-20px"
          >
            <Text fontSize="12px" textColor="grey">
              {formData.gameDuration !== ''
                ? 'Estimated duration. ' +
                  Math.round(formData.gameDuration * 0.6) +
                  ' mins'
                : ''}
            </Text>
          </FormControl>
          <FormControl
            display="flex"
            alignItems="center"
            justifyContent={'space-between'}
            mt="10px"
          >
            <FormLabel
              htmlFor="email-"
              mb="0px"
              fontSize="sm"
              fontWeight="bold"
              color={textColorPrimary}
            >
              Author Name
            </FormLabel>
            <Switch
              isChecked={formData.gameIsShowAuhorName === 'true' ? true : false}
              color="#fff"
              colorScheme="brandScheme"
              size="md"
              id="gameIsShowAuhorName"
              name="gameIsShowAuhorName"
              onChange={handleChange}
            />
          </FormControl>
          <FormControl
            display="flex"
            alignItems="center"
            justifyContent={'space-between'}
            mt="10px"
          >
            <FormLabel
              htmlFor="email-"
              mb="5px"
              fontSize="sm"
              fontWeight="bold"
              color={textColorPrimary}
            >
              <Text> Additional Welcome Note</Text>
            </FormLabel>

            <Switch
              isChecked={
                formData.gameIsShowAdditionalWelcomeNote === 'true'
                  ? true
                  : false
              }
              // isChecked={formData.gameIsShowAdditionalWelcomeNote}
              color="#fff"
              colorScheme="brandScheme"
              size="md"
              id="gameIsShowAdditionalWelcomeNote"
              name="gameIsShowAdditionalWelcomeNote"
              onChange={handleChange}
            />
          </FormControl>
        </SimpleGrid>
        <SimpleGrid columns={{ base: 1, md: 1 }} gap="20px" mt={'0px'}>
          <FormLabel fontSize="12px" mt="5px" color="gray" htmlFor="Collection">
            An additional Note can be used to set the context or share reference
            material after the Welcome Screen.
          </FormLabel>
        </SimpleGrid>
        <SimpleGrid columns={{ base: 1, md: 1 }} gap="20px" mt={'0px'}>
          {formData.gameIsShowAdditionalWelcomeNote === 'true' && (
            <div>
              <TextField
                disabled={!formData.gameIsShowAdditionalWelcomeNote}
                mb="0px"
                id="Collection"
                name="gameAdditionalWelcomeNote"
                placeholder="You can add a link too. Please paste the entire link starting with https."
                onChange={handleTextWelcomeChange}
                value={formData.gameAdditionalWelcomeNote}
                maxLength={100}
                onKeyPress={checkvalue}
                style={{
                  border: formData.gameIsShowAdditionalWelcomeNoteInvalid
                    ? '1px solid red'
                    : '1px solid #ccc',
                }}
              />

              <Text fontSize={'12px'} ml="2.5px">
                {maxCharacters -
                  (formData?.gameAdditionalWelcomeNote?.length || 0)}{' '}
                Characters left
              </Text>
            </div>
          )}
        </SimpleGrid>
      </Card>
    </Stack>
  );
};
export default WelcomeScreen;
